import { useTranslation } from 'next-i18next';

import { Stepper, StepperVariants } from '@app/components/atoms/stepper';
import { ReservationVariant } from '@app/models';

import { ProgressStepperProps } from './progress-stepper.props';

export const ProgressStepper = ({ activeStep, reservationVariant }: ProgressStepperProps) => {
    const { t } = useTranslation('checkout');

    const stepCount = 2;

    const steps = [
        {
            id: 0,
            title: t(
                reservationVariant === ReservationVariant.RealTime
                    ? 'stepper.step1.realtime'
                    : 'stepper.step1.onRequest',
            ),
        },
        {
            id: 1,
            title: t('stepper.step2'),
            status:
                reservationVariant === ReservationVariant.OnRequest && activeStep === stepCount
                    ? StepperVariants.Pending
                    : undefined,
        },
    ];

    return (
        <Stepper
            activeStep={activeStep}
            steps={steps}
            count={stepCount}
            w={{ base: '100%', lg: '48rem' }}
            mt={{
                base: 4,
                lg: 0,
            }}
        />
    );
};
